import React from 'react';
import '../styles/theme.css';
import '../styles/Landing.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LandingEntryBand from '../components/LandingEntryBand';
import LandingProductExplanation from '../components/LandingProductExplanation';
import LandingHero from '../components/LandingHero';
/* IMPORTS */

function LandingPage() {
  return (
    <div className="la-root">
      <div id="navbar" className="la-slot-navbar">
        <Navbar activePage={"Landing"} />
      </div>
      <div id="landinghero" className="la-slot-landinghero">
        <LandingHero />
      </div>
      <div id="landingproductexplanation" className="la-slot-landingproductexplanation">
        <LandingProductExplanation />
      </div>
      <div id="landingentryband" className="la-slot-landingentryband">
        <LandingEntryBand />
      </div>
      <div id="footer" className="la-slot-footer">
        <Footer />
      </div>
    </div>
  );
}

export default LandingPage;